import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { get_calendar_notification_action, get_job_changes_notification_action, mark_job_changes_notification_read_action } from "../../../redux/_actions";


function useNotifications(props) {
  const [calendarNotifications, setCalendarNotifications] = useState([]);
  const [jobChangesNotification, setJobChangesNotifications] = useState([]);
  const [loading, setLoading] = useState();

  const { calendarNotificationData } = useSelector((state) => state.get_calendar_notification_reducer);
  const { jobChangesNotificationData } = useSelector((state) => state.get_job_changes_notification_reducer);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    callApi();
  }, []);

  useEffect(() => {
    if (calendarNotificationData?.data) {
      setCalendarNotifications(calendarNotificationData?.data);
    }
  }, [calendarNotificationData]);


  useEffect(() => {
    if (jobChangesNotificationData?.data) {
      setJobChangesNotifications(jobChangesNotificationData?.data);
    }
  }, [jobChangesNotificationData]);

  const callApi = async () => {
    setLoading(true);
    await dispatch(get_calendar_notification_action());
    await dispatch(get_job_changes_notification_action());
    setLoading(false);
  };

  const onExploreJobsClick = () => {
    navigate(
      `/job-board`
    );
  };


  const onClickNotification = async (candidateId, jobId,type, mentorId) => {
    const user = JSON.parse(localStorage.getItem("jigsawUser"));
    await dispatch(mark_job_changes_notification_read_action(jobId, { read: true }));
    if (user?.user && user.user?.role === "hiring_manager" || user?.user && user.user?.role === "mentor") {
     
      if (type === "candidate_application_status") {
        navigate(`/hiring-manager-kanboard/${jobId}`, {
          state: { id: jobId }
        });
      }
    }

    //for hiringmanager only
    if (user?.user && user.user?.role === "hiring_manager") {
      if (type === "candidate_interview_stage" || type === "candidate_job_posting") {
        navigate(`/applicant-profile-dashboard/${candidateId}`);
      }
      if (type === "mentor_job_posting") {
        navigate(`/view-mentor-profile/${mentorId}`, {
          state: { id: mentorId },
        });
      }
    }

    //for mentor only
    if (user?.user && user.user?.role === "mentor") {
      if (type === "candidate_interview_stage" || type === "candidate_job_posting") {
        navigate(`/view-applicant-profile-dashboard/${candidateId}`, {
          applicantId: candidateId , jobId: jobId
        });
      }
      if (type === "candidate_application_status") {
        navigate(`/mentor-kanboard/${jobId}`, {
          state: { id: jobId }
        });
      }
      if (type === "candidate_interview_schedule" || type === "unregistered_user_interview_schedule") {
        navigate(`/calender-dashboard`);
      }
    }

    //for candidate only

    if (user?.user && user.user?.role === "candidate") {
      if (type === "candidate_application_status" || type === "candidate_interview_stage" || type === "assign_event_link_to_candidate"
       || type === "candidate_interview_stage") {
        navigate(`/applied-jobs-expanded`, {
          state: { job_id: jobId }
        });
      }

    }
  };

  return {
    loading,
    calendarNotifications,
    jobChangesNotification,
    onExploreJobsClick,
    onClickNotification
  };
}
export default useNotifications;
